"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// << using-types-import
const video_client_core_1 = require("@video/video-client-core");
const mobx_1 = require("mobx");
const canvas_placeholder_1 = require("../utils/active-placeholder/canvas-placeholder");
const video_placeholder_1 = require("../utils/active-placeholder/video-placeholder");
class CallState extends video_client_core_1.ObservableEventEmitter {
    get broadcastPaused() {
        return this.pausedBroadcast;
    }
    constructor(opts) {
        super();
        this.call = null;
        this.broadcast = null;
        this.pausedBroadcast = false;
        this.activePlaceholder = null;
        this.zeroBitrateHandler = [];
        (0, mobx_1.makeObservable)(this, {
            // observers
            call: mobx_1.observable,
            broadcast: mobx_1.observable,
            pausedBroadcast: mobx_1.observable,
            broadcastPaused: mobx_1.computed,
            pauseBroadcast: mobx_1.action,
        });
        if ((opts === null || opts === void 0 ? void 0 : opts.activePlaceholder) != null) {
            const { pauseBehaviour, options } = opts.activePlaceholder;
            if (pauseBehaviour === "video" && video_placeholder_1.VideoPlaceholder.isSupported()) {
                this.activePlaceholder = new video_placeholder_1.VideoPlaceholder(options);
            }
            else if (pauseBehaviour === "canvas" && canvas_placeholder_1.CanvasPlaceholder.isSupported()) {
                this.activePlaceholder = new canvas_placeholder_1.CanvasPlaceholder(options);
            }
        }
        this.addInnerDisposer((0, mobx_1.reaction)(() => this.call, (newCall, oldCall) => {
            if (oldCall != null) {
                oldCall.off("zeroBitrate", this.onZeroBitrate);
            }
            if (newCall != null) {
                newCall.on("zeroBitrate", this.onZeroBitrate);
            }
        }));
        if (this.activePlaceholder != null) {
            this.addInnerDisposer(this.activePlaceholder);
        }
    }
    onZeroBitrate(ev) {
        this.zeroBitrateHandler.forEach((h) => h(ev));
    }
    /**
     * Check if the broadcast is active.
     */
    get isBroadcasting() {
        var _a;
        return ((_a = this.broadcast) === null || _a === void 0 ? void 0 : _a.state) === "active";
    }
    //
    // get isOwner(): boolean {
    //   return this.call?.isOwner ?? false;
    // }
    //
    async toggleBroadcast(callOptionsOrId, broadcastOptions, mediaStreamController, videoClient) {
        if (this.isBroadcasting) {
            return this.stopBroadcast();
        }
        if (typeof callOptionsOrId === "string") {
            return this.startBroadcastOnExistingCall(callOptionsOrId, broadcastOptions, mediaStreamController, videoClient);
        }
        return this.startBroadcastOnNewCall(callOptionsOrId, broadcastOptions, mediaStreamController, videoClient);
    }
    async startBroadcastOnNewCall(callOptions, broadcastOptions, mediaStreamController, videoClient) {
        if (this.call != null) {
            throw new Error("Cannot start broadcast on a call that is already active");
        }
        this.call = await videoClient.createCall(callOptions);
        return this.startBroadcastOnExistingCall(this.call.id, broadcastOptions, mediaStreamController, videoClient);
    }
    /**
     * Joins the existing call and starts the broadcast.
     */
    async startBroadcastOnExistingCall(callId, options, mediaStreamController, videoClient) {
        if (this.broadcast != null) {
            throw new Error("Broadcast is already active");
        }
        if (this.call == null || this.call.state !== "active") {
            this.call = await videoClient.joinCall(callId);
        }
        this.call.on("viewerKicked", () => this.stopBroadcast());
        this.broadcast = await this.call.broadcast(mediaStreamController, options);
    }
    async stopBroadcast() {
        var _a, _b, _c, _d;
        if ((_a = this.call) === null || _a === void 0 ? void 0 : _a.isOwner) {
            (_b = this.call) === null || _b === void 0 ? void 0 : _b.dispose("call disposed via callState stopBroadcast()");
            (_c = this.call) === null || _c === void 0 ? void 0 : _c.close("Closing via callState stopBroadcast()");
            this.call = null;
        }
        else {
            (_d = this.broadcast) === null || _d === void 0 ? void 0 : _d.dispose("broadcast disposed via callState stopBroadcast()");
        }
        this.broadcast = null;
    }
    async pauseBroadcast(mediaStreamController) {
        if (!this.isBroadcasting || this.broadcast == null || this.activePlaceholder == null || this.pausedBroadcast) {
            return;
        }
        // start pauseBroadcast
        await this.activePlaceholder.start();
        if (this.activePlaceholder.element != null) {
            mediaStreamController.capturable = { element: this.activePlaceholder.element };
            mediaStreamController.videoDisabled = "placeholder";
            mediaStreamController.audioDisabled = "placeholder";
            this.pausedBroadcast = true;
        }
    }
    unpauseBroadcast(mediaStreamController) {
        if (!this.isBroadcasting || this.broadcast == null || this.activePlaceholder == null || !this.pausedBroadcast) {
            return;
        }
        this.activePlaceholder.stop();
        mediaStreamController.capturable = null;
        mediaStreamController.videoDisabled = false;
        mediaStreamController.audioDisabled = false;
        this.pausedBroadcast = false;
    }
    async togglePauseBroadcast(mediaStreamController) {
        if (!this.isBroadcasting || this.broadcast == null || this.activePlaceholder == null) {
            return;
        }
        if (!this.pausedBroadcast) {
            await this.pauseBroadcast(mediaStreamController);
        }
        else {
            this.unpauseBroadcast(mediaStreamController);
        }
    }
}
exports.default = CallState;
//# sourceMappingURL=call-state.js.map